import {
  defaultSystemCode,
  defaultTrader,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader,
  TraderFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface BibliographyRealDetailOrder {
  id: number
  holdingBranchCode: SystemCode
  callNo: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  processedDate: string
  processedBranchCode: SystemCode
  workMemo: string
  displayMemo: string
  localMemo: string
  revision: number
  traderCode: Trader
  acceptType: SystemCode
  orderPrice: number
}

export function BibliographyRealDetailOrderFromJSON(
  json: any
): BibliographyRealDetailOrder {
  return {
    id: exists(json, 'id') ? json.id : 0,
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    callNo: exists(json, 'call_no') ? json.call_no : '',
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    processedDate: exists(json, 'processed_date')
      ? dateToPlainFormat(json.processed_date)
      : '',
    processedBranchCode: exists(json, 'processed_branch_code')
      ? SystemCodeFromJSON(json.processed_branch_code)
      : defaultSystemCode(),
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    revision: exists(json, 'revision') ? json.revision : 0,
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    orderPrice: exists(json, 'order_price') ? json.order_price : 0
  }
}
